export function MoneyFormat(value) {
    if (value === null || value === undefined || value === '') return '';
    return parseFloat(value).toLocaleString('pl-PL', {style: 'currency', 'currency': 'PLN'})
}

export function NumericMoneyFormat(value) {
    if (value === null || value === undefined || value === '') return '';
    return Math.round((value + Number.EPSILON) * 100) / 100;
}